<!-- Generated template for the EditInputComponent component -->
<div *ngIf="!isEdit" [innerHTML]="modelData | nl2br"></div>

<ion-item *ngIf="isEdit && type==='text'">
    <ion-input (ngModelChange)="modelChanged($event)" [ngModel]="modelData" [placeholder]="placeholder"
               [type]="type"></ion-input>
    <ion-button (click)="buttonClick($event)" *ngIf="hasButton" slot="end">
        <ion-icon name="wifi"></ion-icon>
    </ion-button>
</ion-item>
<ion-item *ngIf="isEdit && type==='number'">
    <ion-input (ngModelChange)="modelChanged($event)" [ngModel]="modelData" [placeholder]="placeholder"
               [type]="type"></ion-input>
</ion-item>
<ion-item *ngIf="isEdit && type==='textarea'">
    <ion-textarea (ngModelChange)="modelChanged($event)" [ngModel]="modelData"></ion-textarea>
</ion-item>
<ion-item *ngIf="isEdit && type==='select'">
    <ion-select (ngModelChange)="modelChanged($event)" [ngModel]="modelData" [placeholder]="placeholder">
        <ion-select-option *ngFor="let option of options" [value]="option.key">{{option.value}}</ion-select-option>
    </ion-select>
</ion-item>
<ion-item *ngIf="isEdit && type==='date'">

    <app-ion-datetime *ngIf="isApp"  style="display:contents;"
    class="form-control"  
    (ngModelChange)="modelChanged($event)" [(ngModel)]="modelData"
    name="dateTo" 
    cancelText="{{ 'Cancel' | translate}}"
    displayFormat="DD.MM.YYYY"
    doneText="{{ 'TakeOver' | translate }}"
    [triggerId]="'dateTo'"
    [title]="'VisibleFrom' | translate"
    presentation="date"
>
</app-ion-datetime>

    <ion-input *ngIf="isBrowser" type="tel" (ngModelChange)="modelChanged($event)" [ngModel]="modelData | checkDate | date:'dd.MM.yyyy'" [placeholder]="placeholder"></ion-input>

</ion-item>

